import React, { useContext, useEffect, useState } from "react";
import useMasterData from "../../Hooks/useMasterData";
import { showToast } from "../../../utils/utility";
import { useSurveyData } from "../../../libs/data-access";
import { AppContext } from "../../../AppContext";

const useSchoolSurvey = () => {
  const { districts, getDistrictByStateId } = useMasterData();

  const {
    isSidebarCollapsed,
    handleLogout,
    role,
    user,
    currentRotes,
    setCurrentRoutes,
  } = useContext(AppContext);

  const { fetchSurveyData, postSurveyData } = useSurveyData();

  const [isLoading, setIsLoading] = useState<any>(false);
  const [saveLoading, setSaveLoading] = useState<any>(false);
  const [detailLoading, setDetailLoading] = useState<any>(false);
  const [loadingSurveyId, setLoadingSurveyId] = useState<number | null>(null);
  const [data, setData] = useState<any>([
    {
      survey_Id: 18,
      survey_Title: "testing",
      survey_Description: "testing description",
      survey_Start_Date: "02-10-2026",
      survey_End_Date: "02-10-2026",
    },
    {
      survey_Id:16,
      survey_Title: "testing",
      survey_Description: "testing description",
      survey_Start_Date: "02-10-2026",
      survey_End_Date: "02-10-2026",
    },
  ]);

  const [surveyQuestionEnable, setSurveyQuestionEnable] = useState<any>(false);
  const [surveyDetails, setSurveyDetails] = useState<any>(null);
  const [questionGroups, setQuestionGroups] = useState<any[]>([]);

 const getSurveyById = async (id: number) => {
  setSurveyDetails(null);
   try {
     setDetailLoading(true);
     setLoadingSurveyId(id); // ✅ track which row clicked

     const res = await fetchSurveyData(`GetSurevyById?surevy_Id=${id}`);

     if (res.isSuccess) {
       setSurveyDetails(res?.data[0]);
       setSurveyQuestionEnable(true); // ✅ open detail screen
     } else {
       showToast({
         type: "error",
         message: res?.message || "Error fetching survey",
       });
       setSurveyDetails(null);
     }
   } catch (error) {
     showToast({
       type: "error",
       message: "Something went wrong",
     });
     setSurveyDetails(null);
   } finally {
     setDetailLoading(false);
     setLoadingSurveyId(null); // ✅ reset
   }
 };

  const getAllSurvey = async () => {
    setData([])
    try {
      setIsLoading(true);

      const res = await fetchSurveyData(
        `GetAllSurveyListByDistrictId?districtid=${user?.details?.schoolUserDetails?.district_Id}`,
      );

      if (res.isSuccess) {
        setData(res?.data);
      } else {
        showToast({
          type: "error",
          message: res?.message || "Error fetching survey",
        });
        setData([]);
      }
    } catch (error) {
      showToast({
        type: "error",
        message: "Something went wrong",
      });
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ format like mobile
  const formatQuestions = (groups: any[]) => {
    return groups.map((group) => ({
      ...group,
      questions: group.questions.map((q: any) => ({
        ...q,
        selectedValue: "",
        survey_Options_List: q.survey_Options_List?.map((opt: any) => ({
          ...opt,
          selected: false,
        })),
      })),
    }));
  };

  // ✅ update answer
  const handleUpdateAnswer = (
    groupIndex: number,
    questionIndex: number,
    optionIndex?: number,
    value?: string,
  ) => {
    const updated = [...questionGroups];
    const question = updated[groupIndex].questions[questionIndex];

    if (value !== undefined) {
      question.selectedValue = value;
    }

    if (optionIndex !== undefined) {
      if (question.survey_Question_Type_Id === 1) {
        question.survey_Options_List.forEach(
          (opt: any) => (opt.selected = false),
        );
        question.survey_Options_List[optionIndex].selected = true;
      } else {
        question.survey_Options_List[optionIndex].selected =
          !question.survey_Options_List[optionIndex].selected;
      }
    }

    setQuestionGroups(updated);
  };

  // ✅ save
  //  const handleSave = () => {
  //    const payload = questionGroups.map((group) => ({
  //      questionSectionTitle: group.question_Section_Title,
  //      questionSectionDescription: group.question_Section_Description,
  //      questions: group.questions.map((q: any) => ({
  //        question: q.survey_Question_Title,
  //        questionId: `${q.survey_Question_Type_Id}_${q.survey_Sub_Question_Type_Id}`,
  //        selectedOptions: q.survey_Options_List
  //          ?.filter((opt: any) => opt.selected)
  //          .map((opt: any) => opt.survey_Options),
  //        valueEnteredByUser: q.selectedValue,
  //      })),
  //    }));

  //    console.log("FINAL PAYLOAD", payload);
  //  };

  const handleSave = async () => {
    const payload = questionGroups.map((group) => ({
      questionSectionTitle: group.question_Section_Title,
      questionSectionDescription: group.question_Section_Description,
      questions: group.questions.map((q: any) => ({
        question: q.survey_Question_Title,
        questionId: `${q.survey_Question_Type_Id}_${q.survey_Sub_Question_Type_Id}`,
        selectedOptions: q.survey_Options_List
          ?.filter((opt: any) => opt.selected)
          .map((opt: any) => opt.survey_Options),
        valueEnteredByUser: q.selectedValue,
      })),
    }));
    let SurveyPayload = {
      survey_Id: surveyDetails?.survey_Id,
      user_Id: String(user?.user_Id),
      role_Id: user?.role_Id,
      designation_Id: 0,
      district_Id: user?.details?.schoolUserDetails?.district_Id,
      answer_Groups: JSON.stringify(payload),
    };
    setSaveLoading(true);
    const res = await postSurveyData(`SaveSurvey`, SurveyPayload);
    if (res.isSuccess) {
      showToast({
        type: "success",
        title: "Successfully",
        message: "New survey posted successfully",
      });
    } else {
      showToast({
        type: "error",
        message: res?.message ?? "Fail to create new survey",
      });
    }
    setSaveLoading(false);
  };

  useEffect(() => {
    if (surveyDetails?.question_Groups) {
      setQuestionGroups(formatQuestions(surveyDetails?.question_Groups));
    }
  }, [surveyDetails]);

  useEffect(() => {
    getDistrictByStateId(1);
    getAllSurvey();
  }, []);

  return {
    isLoading,
    data,
    districts,
    surveyQuestionEnable,
    setSurveyQuestionEnable,
    surveyDetails,
    handleSave,
    handleUpdateAnswer,
    questionGroups,
    getSurveyById,
    detailLoading,
    loadingSurveyId,
  };
};

export default useSchoolSurvey;
